<template>
    <div class="table-list biz-process">
        <virtual-account  :key="'a'+componentKey" :task="taskId"></virtual-account>
        <view-house-detail  :key="'b'+componentKey" :task="taskId" :tasker="takerName"></view-house-detail>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="house">房源地址</span>
            <span class="name">受託人</span>
            <span class="pay-way">付款方式</span>
            <span class="status">委託狀態</span>
            <span class="member">業務</span>
            <span class="task-date">委託時間</span>
            <span class="bonus">獎金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="taskProcessList.length != 0 && filterByWord.length == 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
            </div>
            <div v-else-if="taskProcessList.length == 0" class="is-empty">0 筆資料</div> 
            <ul v-else>
                <li v-for="(task,index) in filterByWord" :key="index">
                    <div class="house">
                        <div v-if="task.houseCoverImage" class="cover">
                            <img :src="imageUrl(task.houseCoverImage)" alt="">
                        </div>
                        <div v-else class="cover">
                            <img src="@/assets/img/component/houseCard/default.svg" alt="">
                        </div>
                        <div class="house-name">
                            {{task.houseName}}
                        </div>
                    </div>
                    <span class="name">{{task.taskTakerName}}</span>
                    <span class="pay-way">{{transPayWay(task.paymentType)}}</span>
                    <span class="status">
                        <span class="blue" v-if="task.taskStatus == 2">進行中</span>
                        <span class="red" v-if="task.taskStatus == 9 ">待付款</span>
                        <span class="gray" v-if="task.taskStatus == 1 ">待接受</span>
                    </span>
                    <div class="member">{{task.agentName}}</div>
                    <span class="task-date">{{getFormatDate(task.taskBeginTime)}}~{{getFormatDate(task.taskEndTime)}}</span>
                    <span class="bonus">{{toCurrency(task.taskBonus)}}</span>
                    <span v-if="task.taskStatus == 2" class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="getViewHouseDetail(task.taskCid,task.taskTakerName), $analyticsBiz.logEvent('看屋明細', { screen_name: '看屋明細'})">看屋明細</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                    <span v-if="task.taskStatus == 9" class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="getVirtualAccount(task.taskCid), $analyticsBiz.logEvent('付款明細', { screen_name: '付款明細'})">付款明細</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import Modal from '@/components/widge/Modal.vue';
import VirtualAccount from '@/components/bussiness/widges/modals/virtualAccount.vue';
import ViewHouseDetail from '@/components/bussiness/widges/modals/viewHouseDetail.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            componentKey: 0,
            // taskProcessList: [],
            taskId: null,
            takerName: null,
            filterEmpty: false,
            taskProcessDataEmpty: false,
            taskProcessDataError: false,
            alarm: false,   
            deleteId: '',
            isDefault: false,
            isLoading: true,
            // totalPage: 0
        }
    },
    created () {
        this.$store.dispatch('getBizTaskProcessMgtList', 1)
        .then(()=>{
            this.isLoading = false
        })
    },
    watch: {
        totalPage: function (page) {
            if(page > 1){
                for (let i = 2; i <= page; i++) {
                    this.$store.dispatch('getBizTaskProcessMgtList', i)
                }
            }
        },
        filterByWord:{
            handler: function (val) {
                this.$store.dispatch('setBizTaskProcessMgtFilterResultTotal', val.length)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false

            // if( value.ref == 'finished' ){
            //     if(value.id == 1){
            //         this.contractState = [9]
            //     }else if(value.id == 2){
            //         this.contractState = [4, 6, 8]
            //     }else if(value.id == 3){
            //         this.contractState = [3, 5]
            //     }
            // }
        },
        closeModal: function (type) {
            this.alarm = false
        },
        openModal: function () {
            this.alarm = true
            this.deleteId = event.target.dataset.id
        },
        // setFilterWord: function (value) {
        //     this.isDefault = false
        //     this.filterWord = value
        // },
        setFilterDefault: function (value) {
            this.$store.dispatch('setBizTaskProcessMgtFilterDefault')
        },
        getVirtualAccount: function (id) {
            this.componentKey += 1
            this.taskId = id
            document.getElementsByClassName('biz-task-management')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizVirtualAccount'})
        },
        getViewHouseDetail: function (id, taker) {
            console.log(id)
            this.componentKey += 1
            this.taskId = id
            this.takerName = taker
            document.getElementsByClassName('biz-task-management')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizViewHouse'})
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        imageUrl: function (url){
            return constant.imageUrl+url
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        filterByGroup: function () {
            return this.taskProcessList.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.salesName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByStatus: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.status){
                    if(item.taskStatus == this.filterQuery.status ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByPayway: function () {
            return this.filterByStatus.filter((item) => {
                if(this.filterQuery.payway){
                    if(item.paymentType == this.filterQuery.payway ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByBonus: function () {
            return this.filterByPayway.filter((item) => {
                if( this.filterQuery.bonus ){
                    if( this.filterQuery.bonus[1] >= 100000){
                        if( this.filterQuery.bonus[0] <= item.taskBonus){
                            return item
                        }
                    }else{
                        if( this.filterQuery.bonus[0] <= item.taskBonus && this.filterQuery.bonus[1] >= item.taskBonus ){
                            return item
                        }
                    }
                    
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByBonus.filter((item) => {
                if( this.filterWord ){
                    if( item.houseName.includes(this.filterWord) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            taskProcessList: 'GET_BIZ_TASK_PROCESS_MGT_LIST',
            totalPage: 'GET_BIZ_TASK_PROCESS_MGT_TOTAL_PAGE',
            filterQuery: 'GET_BIZ_TASK_PROCESS_MGT_FILTER_QUERY',
            filterWord: 'GET_BIZ_TASK_PROCESS_MGT_FILTER_WORD'
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        RentSelect,
        TableSearch,
        VirtualAccount,
        ViewHouseDetail,
        tableLoading
    }
}
</script>
<style lang="scss" scoped>
    .biz-process{
        .table-list-title .house,
        .table-list-body ul li .house{
            position: relative;
            width: 288px;
            margin-right: 43px;
            display: flex;
            align-items: center;
            img{
                margin-right: 16px;
            }
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 56px;
            margin-right: 43px;
        }
        .table-list-title .pay-way,
        .table-list-body ul li .pay-way{
            width: 60px;
            margin-right: 43px;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            width: 76px;
            margin-right: 43px;
        }
        .table-list-title .member,
        .table-list-body ul li .member{
            width: 56px;
            margin-right: 42px;
        }
        .table-list-title .task-date,
        .table-list-body ul li .task-date{
            width: 156px;
            margin-right: 43px;
        }
        .table-list-title .bonus,
        .table-list-body ul li .bonus{
            width: 58px;
            margin-right: 43px;
            text-align: right;
        }
        .table-list-body .cover{
            width: 120px;
            height: 90px;
            border-radius: 4px;
            margin-right: 16px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            overflow: hidden;
            >img{
                width: 100%;
            }
        }
        .table-list-body .house-name{
            width: 170px;
            line-height: 1.5;
        }
        .table-list-body ul li .status{
            >span{
                width: 76px;
                height: 38px;
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .red{
                background-color: rgba(255, 146, 117, 0.1);
                color: #fc7171;
            }
            .blue{
                background-color: rgba(113, 170, 229, 0.1);
                color: #71aae5;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
        }
    }
    // @media screen and (max-width: 1280px){
    //     .process{
    //         .table-list-title .cover,
    //         .table-list-body ul li .cover{
    //             margin-right: 47px;
    //         }
    //         .table-list-title .task-date,
    //         .table-list-body ul li .task-date{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .house,
    //         .table-list-body ul li .house{
    //             margin-right: 49px;
    //         }
    //         .table-list-title .name,
    //         .table-list-body ul li .name{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .pay-way,
    //         .table-list-body ul li .pay-way{
    //             margin-right: 49px;
    //         }
    //         .table-list-title .status,
    //         .table-list-body ul li .status{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .bonus,
    //         .table-list-body ul li .bonus{
    //             margin-right: 48px;
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/taskMgt/taskProcess/taskProcessList.vue